import styled from 'styled-components'
import { screenSizes } from '@shipt/design-system-themes'
import { FilterTagSection } from '@/features/shop/components/FilterTagSection'
import { ProductFilter } from '@/features/shop/components/ProductFilter'
import { SearchResultsHeader } from '@/features/shop/components/SearchResultsHeader'
import { useTotalActiveFiltersLength } from '@/features/shop/services/Search/hooks'
import { useOnClearAllFilters } from '@/features/shop/components/ProductFilter/interactions/useOnClearAllFilters'
import { type Facet } from '@/features/shop/services/Search/types'
import { Box, Row } from '@shipt/design-system-layouts'

type Props = {
  facets: Facet[]
  children: React.ReactNode
  total_hits: number
  isFetching: boolean
}

export const SearchGridLayer = ({ facets, total_hits, isFetching, children }: Props) => {
  const activeFiltersLength = useTotalActiveFiltersLength(facets)
  const { onClearAllFilters } = useOnClearAllFilters(facets)

  return (
    <div className="fullWidth contentAtTablet">
      <Box margin={{ base: ['lg', 0, 'lg', 'lg'], md: ['lg', 0] }}>
        <SearchResultsHeader facets={facets} isFetching={isFetching} total_hits={total_hits} />
      </Box>
      <Row align="start">
        <FilterWrapper display={{ base: 'none', md: 'block' }} marginRight="sm">
          <FilterTagSection activeFiltersLength={activeFiltersLength} onClick={onClearAllFilters} />
          <ProductFilter facets={facets} />
        </FilterWrapper>
        <ChildrenWrapper>{children}</ChildrenWrapper>
      </Row>
    </div>
  )
}

const FilterWrapper = styled(Box)`
  max-width: 15rem;
  min-width: 15rem;
`

const ChildrenWrapper = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  padding: 0;

  @media ${screenSizes.tablet} {
    width: 9.6875rem;
  }
`
